import { FC, ReactElement, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import {
	BUTTON_SIZES,
	BUTTON_TYPES,
	EvButton,
	EvIllustration,
	FailedIcon
} from '@evinced-private/ui-common';

import './Unauthorized403Page.scss';

const backToEvinced = 'Go Back';
const unauthorizedTitle = 'Access denied';
const unauthorizedMsg = "You don't have permission to perform this action.";

export const Unauthorized403Page: FC = (): ReactElement => {
	const history = useHistory();
	const redirectBackToProductHub = useCallback((): void => {
		history.goBack();
	}, [history]);

	return (
		<div className="error-403">
			<div className="error-403-content">
				<EvIllustration icon={FailedIcon} width={96} height={92} />
				<div className="text-message">
					<p className="title">{unauthorizedTitle}</p>
					<p className="msg">{unauthorizedMsg}</p>
					<EvButton
						type={BUTTON_TYPES.PRIMARY}
						onClick={redirectBackToProductHub}
						size={BUTTON_SIZES.BIG}
					>
						{backToEvinced}
					</EvButton>
				</div>
			</div>
		</div>
	);
};
